import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import Image from 'next/image';

import { statusInfoMap } from '@/constants/cabinet';
import { NewDropdownCard } from '@/components/SvgComponents/NewDropdownCard';
import formatPhoneNumberNew from '@/utils/formatPhoneNumberNew';
import { langFormatter } from '@/utils/languageFormat';
import { Button, ScreenLoader } from '@/ui/index';
import {
  actions as cabinetActions,
  selectors as cabinetSelectors,
  hooks as cabinetHooks,
} from '@/domains/cabinet/index';

import styles from './PopUpList.module.scss';

export const PopUpList = () => {
  const dispatch = useDispatch();
  const { t, lang } = useTranslation();
  const formattedLang = langFormatter({ lang });
  const [accounts, setAccounts] = useState(null);
  const { selectedAccountId } = useSelector(cabinetSelectors.selectCabinet);
  const [getAccountsTrigger, { isFetching }] = cabinetHooks.useGetAccounts();
  const accountFetcher = async () => {
    const accessToken = sessionStorage.getItem('accessToken');

    if (!accessToken) {
      dispatch(cabinetActions.setPopUpStep(1));
      return;
    }

    if (!window.location.href.includes('login' || 'cabinet')) {
      try {
        const accounts = await getAccountsTrigger({
          lang: formattedLang,
          accessToken: sessionStorage.getItem('accessToken'),
        }).unwrap();
        dispatch(cabinetActions.setIsLogged(true));
        setAccounts(accounts);
        dispatch(cabinetActions.setSelectedAccountId(accounts[0].id));
        dispatch(
          cabinetActions.setPhoneNumber(`994${accounts[0]?.phone?.number}`),
        );
      } catch (error) {
        dispatch(cabinetActions.setPopUpStep(1));
        dispatch(cabinetActions.setIsLogged(false));
      }
    }
  };
  useEffect(() => {
    accountFetcher();
  }, []);

  const selectHandler = (option) => {
    if (option?.numberStatus === 'DEACTIVE') {
      return;
    }
    if (option?.numberStatus !== 'DEACTIVE') {
      dispatch(
        cabinetActions.setSelectedAccountId(
          accounts?.find((a) => a?.id === option?.id).id,
        ),
      );
      dispatch(cabinetActions.setPhoneNumber(`994${option?.phone?.number}`));
    }
  };
  return (
    <>
      <ScreenLoader visible={isFetching} />
      <div
        className={styles.listWrapper}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        <h3 className={styles.title}>{t('common:SelectNumber')}</h3>
        <ul className={styles.list}>
          {accounts?.map((option) => (
            <li
              className={classNames({
                [styles.disabled]: option?.numberStatus === 'DEACTIVE',
              })}
              key={option?.id}
              onClick={() => selectHandler(option)}
            >
              <div className={styles.detail_box}>
                <span
                  className={
                    statusInfoMap[
                      option?.numberStatus !== 'DEACTIVE'
                        ? option?.status
                        : option?.numberStatus
                    ].class
                  }
                >
                  {<NewDropdownCard />}
                </span>
                <div className={styles.number_detail}>
                  <h5
                    className={classNames(styles.number, {
                      disabled: option?.numberStatus === 'DEACTIVE',
                    })}
                  >
                    {formatPhoneNumberNew(option?.phone?.number)}

                    {option?.isPrimary && (
                      <span className={styles.label}>{t('cabinet:main')}</span>
                    )}
                  </h5>
                  <p
                    className={classNames([
                      styles.status,
                      statusInfoMap[
                        option?.numberStatus === 'ACTIVE'
                          ? option?.status
                          : option?.numberStatus
                      ].class,
                    ])}
                  >
                    {t(
                      `cabinet:${
                        statusInfoMap[
                          option?.numberStatus === 'ACTIVE'
                            ? option?.status
                            : option?.numberStatus
                        ].text
                      }`,
                    )}
                  </p>
                  {option?.status === 'ACTIVE' &&
                    option?.numberStatus === 'ACTIVE' && (
                      <p className={styles.balance}>
                        • <span>{option?.balance} </span>
                        azn
                      </p>
                    )}
                </div>
              </div>
              {option?.id === Number(selectedAccountId) && (
                <Image
                  src='/assets/checkMark.svg'
                  width={15}
                  height={10}
                  alt='checkmark icon'
                  title='Checkmark Icon'
                />
              )}
            </li>
          ))}
        </ul>
        <div className={styles.buttons}>
          <Button
            onClick={() => {
              dispatch(cabinetActions.setPopUpStep(1));
            }}
            variant='outline'
          >
            {t('common:OtherNumber')}
          </Button>

          <Button
            onClick={() => {
              dispatch(cabinetActions.setPopUpConfirm(true));
            }}
          >
            {t('common:Continue')}
          </Button>
        </div>
      </div>
      \{' '}
    </>
  );
};
